import type { JSX } from 'react';
import type { BoxDimensions } from '@/types/BoundingBox.types';

interface SvgBoxMaskProps {
  scaledBox: BoxDimensions;
  className?: string;
}

const SvgBoxMask = ({ scaledBox, className }: SvgBoxMaskProps): JSX.Element => {
  return (
    <svg className={className}>
      <defs>
        <mask id="spotlight-mask">
          <rect width="100%" height="100%" fill="white" />
          <rect
            x={scaledBox.x}
            y={scaledBox.y}
            width={scaledBox.width}
            height={scaledBox.height}
            fill="black"
            rx="8"
            ry="8"
          />
        </mask>
      </defs>
      <rect
        width="100%"
        height="100%"
        fill="black"
        rx="24"
        ry="24"
        opacity="0.5"
        mask="url(#spotlight-mask)"
      />
    </svg>
  );
};

export default SvgBoxMask;
